export default {
  BusinessLabelHandData: {
    header: {
      labelName: '标签名称',
      labelType: '标签类型',
      status: '标签状态',
    },

    table: {
      labelName: '标签名称',
      labelType: '标签类型',
      changeFlag: '可挪移',
      preview: '标签预览'
    },
    msgWarning: '您选中了正在启用的标签，不可删除'
  },
  BusinessLabelHandPage: {
    title: '基础信息',
    labelName: '标签名称',
    labelType: '标签类型',
    labelStyle: '标签样式',
    textContent: '文字内容',
    textContentText: '请控制文字在6字以内',
    textColor: '选择颜色',
    preview: '标签预览',
    editLabel: '编辑标签',
    addLabel: '新建标签',
  },
};
